<template>
  <v-container>
    <GuideMissedCallsTable />
  </v-container>
</template>

<script>
import GuideMissedCallsTable from "@/components/table/guide/GuideMissedCallsTable";

export default {
  name: "GuideMissedCalls",
  components: { GuideMissedCallsTable },
};
</script>
